import { Compass, BookMarked, Network } from "lucide-react";

const STEPS = [
  {
    n: "01",
    icon: Compass,
    title: "Discover the idea",
    body: "Editor-picked essays on mindmaps, learning, and the books changing how we think.",
  },
  {
    n: "02",
    icon: BookMarked,
    title: "Read the breakdown",
    body: "Short, structured reads. Every article ends with a one-page mind map you can keep.",
  },
  {
    n: "03",
    icon: Network,
    title: "Map your own",
    body: "Take what stuck into SummaryMaps and build your own visual library of books.",
  },
];

export default function HowItWorks() {
  return (
    <section id="how" className="py-20 sm:py-24 lg:py-32 border-t border-ink/5" data-testid="how-it-works-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl">
          <div className="text-[11px] sm:text-xs uppercase tracking-[0.2em] text-brand mb-3">How it works</div>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-semibold leading-tight text-ink">
            Three quiet steps from <span className="italic">curious</span> to <span className="italic">never forget it.</span>
          </h2>
        </div>

        <div className="mt-10 sm:mt-14 grid md:grid-cols-3 gap-5 sm:gap-8">
          {STEPS.map(({ n, icon: Icon, title, body }) => (
            <div key={n} className="bg-white rounded-2xl border border-ink/5 p-6 sm:p-8 hover:-translate-y-1 hover:shadow-[0_20px_50px_-20px_rgba(30,77,58,0.25)] transition-all duration-300" data-testid={`step-${n}`}>
              <div className="flex items-start justify-between">
                <span className="font-serif text-4xl sm:text-5xl text-brand/15 font-bold leading-none">{n}</span>
                <span className="w-10 h-10 rounded-xl bg-brand-soft text-brand flex items-center justify-center">
                  <Icon className="w-5 h-5" />
                </span>
              </div>
              <h3 className="mt-5 sm:mt-6 font-serif text-xl sm:text-2xl text-ink">{title}</h3>
              <p className="mt-2.5 sm:mt-3 text-ink-muted leading-relaxed text-sm sm:text-base">{body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
